<script lang="ts">
    import { h, inject } from 'vue';

    export default defineNuxtComponent({
        props: {
            title: {
                type: String,
                required: false,
                default: 'Debug Info'
            }
        },
        setup(props, ctx) {
            return () => {
                if (import.meta.server) return null;
                if (!inject<boolean>('isDebug', false)) return null;
                const defClass = 'debug-content';
                const bgCssClass = 'checkered-bg';

                switch (true) {
                    case !!ctx.slots.expand:
                        return h(
                            'details',
                            { class: `${defClass} debug-expand-slot` },
                            [
                                h(
                                    'summary',
                                    { class: 'cursor-pointer font-weight-medium' },
                                    props.title
                                ),
                                ctx.slots.expand({ bgCssClass })
                            ]
                        );
                    case !!ctx.slots.default:
                        return h(
                            'div',
                            { class: defClass },
                            ctx.slots.default?.({ bgCssClass })
                        );
                }

                return null;
            };
        }
    });
</script>
